import { createSlice } from "@reduxjs/toolkit";

const multiselectApiOptionsSlice = createSlice({
  name: 'fetchedOptions',
  initialState: {
    fetchedOptions: {}
  },
  reducers: {
    setApiOptions: (state, action) => {
      const { apiName, apiOptions, params } = action.payload;
      state.fetchedOptions[apiName] = apiOptions;
      state.fetchedOptions["params"] = params;
    },
  }
});

export const { setApiOptions } = multiselectApiOptionsSlice.actions;

export default multiselectApiOptionsSlice.reducer;

export const getApiOptions = (state) => {
  return state.multiselectApiOptions.fetchedOptions;
}

export const getSelectedFilters =  (state) => {
  return state.multiselectApiOptions.fetchedOptions.params?.filters;
}
